import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
  id: string;
  email: string;
  role: string;
  isPremium: boolean;
  fullName?: string;
  phone?: string;
  photo?: string;
  occupation?: string;
  location?: string;
  languages?: string[];
  aboutMe?: string;
  joinDate?: string;
}

interface UserStore {
  users: Record<string, User>;
  addUser: (email: string, user: User) => void;
  updateUser: (email: string, user: User) => void;
  removeUser: (email: string) => void;
  resetStore: () => void;
}

// Initial admin user
const initialUsers = {
  'admin@subleasehub.com': {
    id: 'admin@subleasehub.com',
    email: 'admin@subleasehub.com',
    role: 'admin',
    isPremium: true,
    fullName: 'Admin User',
    joinDate: new Date().toISOString()
  }
};

export const useUserStore = create<UserStore>()(
  persist(
    (set) => ({
      users: initialUsers,
      
      addUser: (email, user) => 
        set((state) => ({
          users: { ...state.users, [email]: user }
        })),
        
      updateUser: (email, user) =>
        set((state) => ({
          users: { ...state.users, [email]: user }
        })),
        
      removeUser: (email) =>
        set((state) => {
          const { [email]: removed, ...rest } = state.users;
          return { users: rest };
        }),

      resetStore: () => set({ users: initialUsers })
    }),
    {
      name: 'user-store',
      version: 1
    }
  )
);